import React from 'react'
import { Outlet } from 'react-router-dom'
import { AsideMenu } from '../../../components/Dashboard/AsideMenu'
import './style.scss'
export const ContentLayoutPage = () => {
  return (
    <section className="container dashboard">
      <div className="row mt-n5">
        <AsideMenu />
        <div className="col-md-8 offset-lg-1 pb-5 mb-2 mb-lg-4 pt-md-5 mt-n3 mt-md-0">
        <Outlet/>
        </div>
      </div>
    </section>
  )
  // return (
  //   <>
  //     <div className='container'>
  //       <div className="row">
  //         <div className="col-lg-3 col-md-4 col-sm-12">
  //           <AsideMenu />
  //         </div>
  //         <div className="col-lg-9 col-md-8 col-sm-12">
  //           <div className="content-dashboard">
  //             <div className="row mt-5 mb-5 pb-5">
  //               <Outlet />
  //             </div>
  //           </div>

  //         </div>
  //       </div>
  //     </div>
  //   </>
  // )
}
